import { useQuery } from '@apollo/react-hooks';
import { modeOfStudyOptions } from '../../Application/components/ApplicationForm/ProgrammeChoice/options';
import { SUPERVISOR_TYPE } from '../../../utils';
import { getProgrammeTableText } from '../../DualJointManagement/components';
import { getOptionsLabel } from '../../Monitor/components';
import { PAGE_TEXT } from '../../Nomination/components';
import { GET_INTERVIEW_LIST_PAGE_DATA } from './GET_INTERVIEW_LIST_PAGE_DATA.gql';
import type { InterviewListPageData, PageData } from './types';

const fundingSourceValues = PAGE_TEXT.FUNDING_SOURCE.FUNDING_SCHEME.VALUES;
export const useGetInterviewListPageData = (
  filter: any,
): PageData<InterviewListPageData[]> => {
  const { data, loading, error, refetch } = useQuery(
    GET_INTERVIEW_LIST_PAGE_DATA,
    {
      variables: { filter, sort: {}, paginator: {} },
      fetchPolicy: 'network-only',
    },
  );

  const applications = data?.applicationViewsPaginated?.data ?? [];

  const interviewListPageData = applications.reduce(
    (acc: any, element: any) => {
      if (!(element as boolean)) {
        return acc;
      }
      const {
        id: applicationId,
        applicationNo,
        applicant,
        programmeChoice,
        nomination,
        status,
      } = element ?? {};

      const {
        entryYear,
        department,
        studyMode,
        researchArea,
        programme: programmeLevel,
        programmeType,
      } = programmeChoice ?? {};
      const programme = getProgrammeTableText(programmeLevel, programmeType);

      const { fundings, supervisors } = nomination ?? {};

      const chiefSupervisorInfo =
        supervisors?.find((supervisor: any) => {
          return supervisor?.type === SUPERVISOR_TYPE.CHIEF_SUPERVISOR;
        }) ?? {};
      const { netId, title, surname, givenName } = chiefSupervisorInfo ?? {};
      const chiefSupervisor = `${title} ${surname?.toUpperCase()} ${givenName}(${netId})`;

      const studyModeLabel = getOptionsLabel(modeOfStudyOptions, studyMode);

      const tableData: InterviewListPageData = {
        applicationId,
        applicationNo,
        applicantName: `${applicant?.name?.surname?.toUpperCase()} ${applicant?.name?.givenName}`,
        entryYear,
        department,
        programme,
        chiefSupervisor,
        studyMode: studyModeLabel,
        researchArea,
        fundingScheme:
          (fundings ?? [])?.length === 0
            ? ['N/A']
            : fundings?.map(
                (funding: any) =>
                  fundingSourceValues[
                    funding?.source as keyof typeof fundingSourceValues
                  ],
              ),
        rawStatus: status,
        status,
      };
      return [...acc, tableData];
    },
    [] as InterviewListPageData[],
  );

  return { data: interviewListPageData, loading, error, refetch };
};
